@if (pageReady && gridConfig) {
    <div class="detail-page-card">
        <div class="detail-page-card-title">
            {{ 'fieldworkExecution.title' | t }}
            @if (saveCalls != null) {
                <i
                    [title]="
                        saveCalls > 0
                            ? ('fieldworkExecution.savingChanges' | t)
                            : ('fieldworkExecution.changesSaved' | t)
                    "
                    class="ms-2 fas fa-{{ saveCalls > 0 ? 'circle-notch fa-spin' : 'check green' }}"
                ></i>
            }
        </div>
        <div class="detail-page-card-actions">
            <button class="btn btn-raised" (click)="loadGrid()">
                <i class="fas fa-sync"></i>
                <span class="ms-2">{{ 'fieldworkExecution.reloadButton' | t }}</span>
            </button>
        </div>
        <div class="detail-page-card-body overflow-auto">
            <cerrix-grid-editor [config]="gridConfig"></cerrix-grid-editor>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
